import React from 'react';
import { VisitModalContextProvider } from './VisitModalContext';
import VisitModal from './nested/modal';
function VisitEditModal(params) {
    return (React.createElement(VisitModalContextProvider, { id: params.id, onClose: params.onClose, onSave: params.onSave },
        React.createElement(VisitModal, null)));
}
export default VisitEditModal;
